import { BCMSRecord, NavLink, Outlet, useGlobalController, useParams, useRouteData } from "@bcm-dev/bcms-vite";
import PageLayoutContainer from "compid/shared/containers/PageLayoutContainer";
import CenterColumnContainer from "compid/shared/containers/PageLayoutContainer/containers/CenterColumnContainer";
import InfoNotificationView from "compid/shared/views/Notifications/InfoNotificationView";
import SuccessNotificationView from "compid/shared/views/Notifications/SuccessNotificationView";
import { Account, Autopay, Bill, Biller, Payment, Reminder } from "model";
import React from "react";
import { BillerLogoView } from "../..";
import BillerDetailsEditConfirmation from "../BillerDetailsEditConfirmation";
import "./styles.css";

/**
 * @function BillerDetailsMobileView
 * @return {React.Component}
 * @exported true
 * @description This is the component that displays the mobile layout for the BillerDetailsPage.
 */
export default function BillerDetailsMobileView(props) {
  const { route } = useRouteData();
  const controller = useGlobalController();
  const { id } = useParams();

  BCMSRecord.globalControllerFor([ Biller, Account, Payment, Bill, Autopay, Reminder ], controller);
  // Replace the state so it doesn't persist on a page reload
  window.history.replaceState({}, document.title);

  const markedBillAsPaid = route === null ? false : route.markedBillAsPaid;
  const hasRouteData = route ? true : false;

  let successMessage = markedBillAsPaid ? "You have successfully marked your bill as paid" : undefined;
  
  if(hasRouteData) {
    if(route.autopayDeleted === "true") {
      successMessage = Autopay.getAutopaySuccessMessage(route);
    }
  }

  let biller = id !== undefined ? Biller.initByID(id) : Biller.firstBiller(controller.state);
  biller = biller !== undefined ? biller : Biller.firstBiller(controller.state);

  return(
    <div  className="biller-details-mobile-view">
      <PageLayoutContainer>
        <CenterColumnContainer>
          { biller.paymentType === "instantPayment" && <InfoNotificationView text="Same-day payment delivery is available." icon="ZapIcon" className="same-day-notification" /> }
          { biller.paymentType === "withinMinutes" && <InfoNotificationView text="Payment delivery within minutes is available" icon="ZapIcon" className="within-minutes-notification" /> }

          <BillerDetailsEditConfirmation />

          { successMessage !== undefined && <SuccessNotificationView message={ successMessage } showClose={ false } /> }

          <div className="flex-width">
            <BillerLogoView />
          </div>
        </CenterColumnContainer>

        <BillerDetailsMobileTabs />
      </PageLayoutContainer>
    </div>
  );
}

/**
 * @function BillerDetailsMobileTabs
 * @return {React.Component}
 * @exported false
 * @description This is the component that displays the tabs for the mobile view. It also renders the sub-routes using an Outlet.
 */
function BillerDetailsMobileTabs(props) {
  const { id } = useParams();
  return(
    <div className="biller-details-mobile-tabs">
      <div className="tabs-container flex-container flex-horizontal align-center add-biller-tabs">
        <NavLink className="tab-item flex-width text-center" activeClassName="active-tab" activeRoutes={["/billerDetails/details/"+id]} to={"/billerDetails/details/"+id}>
          <span className="tab-text" data-point="Details_Tab">DETAILS</span>
        </NavLink>
        <NavLink className="tab-item flex-width text-center" activeClassName="active-tab" activeRoutes={["/billerDetails/activity/"+id]} to={"/billerDetails/activity/"+id}>
          <span className="tab-text"  data-point="Activity_Tab">ACTIVITY</span>
        </NavLink>
      </div>
      <Outlet />
    </div>
  );
}
